import {
	API_TRIP_WIDGET_TYPE,
	ApiTripWallPinCounter,
	ApiTripWidget,
	ApiTripWidgetItineraryCounter,
	ApiTripWidgetNoteCounter,
	ApiTripWidgetSpotCounter,
	ApiTripWidgetStore,
	ApiTripWidgetTaskCounter,
	ApiTripWidgetTravelerCounter,
} from './apiTypes'
import {
	TRIP_WIDGET_TYPE,
	TripWidget,
	TripWidgetDocumentCounter,
	TripWidgetItineraryCounter,
	TripWidgetSpotCounter,
	TripWidgetStore,
	TripWidgetTaskCounter,
	TripWidgetTravelerCounter,
	TripWidgetWallPinCounter,
} from '~/models/TripWidget'

export class TripWidgetEntityMapper {
	static toTripWidgets(apiWidgets: ApiTripWidget[]): TripWidget[] {
		return apiWidgets
			.map((apiWidget) => this.toTripWidget(apiWidget))
			.filter((widget) => widget !== undefined)
	}

	static toTripWidget(apiWidget: ApiTripWidget): TripWidget | undefined {
		const widgetMappers = {
			[API_TRIP_WIDGET_TYPE.TASK_COUNTER]: (apiWidget: ApiTripWidget) =>
				this.mapTaskCounter(apiWidget as ApiTripWidgetTaskCounter),
			[API_TRIP_WIDGET_TYPE.TRAVELER_COUNTER]: (apiWidget: ApiTripWidget) =>
				this.mapTravelerCounter(apiWidget as ApiTripWidgetTravelerCounter),
			[API_TRIP_WIDGET_TYPE.NOTE_COUNTER]: (apiWidget: ApiTripWidget) =>
				this.mapNoteCounter(apiWidget as ApiTripWidgetNoteCounter),
			[API_TRIP_WIDGET_TYPE.SPOT_COUNTER]: (apiWidget: ApiTripWidget) =>
				this.mapSpotCounter(apiWidget as ApiTripWidgetSpotCounter),
			[API_TRIP_WIDGET_TYPE.WALL_PIN_COUNTER]: (apiWidget: ApiTripWidget) =>
				this.mapWallPinCounter(apiWidget as ApiTripWallPinCounter),
			[API_TRIP_WIDGET_TYPE.ITINERARY_COUNTER]: (apiWidget: ApiTripWidget) =>
				this.mapItineraryCounter(apiWidget as ApiTripWidgetItineraryCounter),
			[API_TRIP_WIDGET_TYPE.STORE]: (apiWidget: ApiTripWidget) =>
				this.mapStore(apiWidget as ApiTripWidgetStore),
		}
		if (!widgetMappers[apiWidget.type]) return
		return widgetMappers[apiWidget.type](apiWidget)
	}

	private static mapTaskCounter(widget: ApiTripWidgetTaskCounter): TripWidgetTaskCounter {
		return {
			type: TRIP_WIDGET_TYPE.TASK_COUNTER,
			data: widget.data,
		}
	}

	private static mapTravelerCounter(
		widget: ApiTripWidgetTravelerCounter
	): TripWidgetTravelerCounter {
		return {
			type: TRIP_WIDGET_TYPE.TRAVELER_COUNTER,
			data: { total: widget.data.total, pictureUrls: widget.data.picture_urls },
		}
	}

	private static mapNoteCounter(widget: ApiTripWidgetNoteCounter): TripWidgetDocumentCounter {
		return {
			type: TRIP_WIDGET_TYPE.DOCUMENT_COUNTER,
			data: widget.data,
		}
	}

	private static mapWallPinCounter(widget: ApiTripWallPinCounter): TripWidgetWallPinCounter {
		return {
			type: TRIP_WIDGET_TYPE.WALL_PIN_COUNTER,
			data: widget.data,
		}
	}

	private static mapSpotCounter(widget: ApiTripWidgetSpotCounter): TripWidgetSpotCounter {
		return {
			type: TRIP_WIDGET_TYPE.SPOT_COUNTER,
			data: { total: widget.data.total, pictureUrls: widget.data.picture_urls },
		}
	}

	private static mapItineraryCounter(
		widget: ApiTripWidgetItineraryCounter
	): TripWidgetItineraryCounter {
		return {
			type: TRIP_WIDGET_TYPE.ITINERARY_COUNTER,
			data: {
				total: widget.data.total,
				startDate: widget.data.start_date ? new Date(widget.data.start_date) : undefined,
				endDate: widget.data.end_date ? new Date(widget.data.end_date) : undefined,
			},
		}
	}

	private static mapStore(widget: ApiTripWidgetStore): TripWidgetStore {
		return {
			type: TRIP_WIDGET_TYPE.STORE,
			data: {
				indispensables: widget.data.essentials,
				activities: widget.data.activities,
				ideas: widget.data.ideas,
			},
		}
	}
}
